import cookies from 'browser-cookies';
import { AxiosRequestConfig } from 'axios';
import { clientAuthAxios, clientAuthV2Axios } from '../clientAuth';
import { wafClientAuthAxios, wafClientAuthV2Axios } from '../awsWaf';
import type { GoogleRegistrationRequestParameters, RegistrationRequestParameters, RegistrationRequestParametersOptionalLastName, RegistrationResponse } from './types';
type DefaultOptionsParams = RegistrationRequestParameters['options'] | GoogleRegistrationRequestParameters['options'];
const getDefaultOptions = (): DefaultOptionsParams => ({
  promo_name: cookies.get('promo'),
  referrer_client_id: cookies.get('referrer_id'),
  signup_page_referrer: document.referrer,
  visitor_uuid: cookies.get('visitor_uuid')
});

/**
 * A function that posts to the `/client-auth-api/api/registration` endpoint.
 *
 * - [Documentation](https://unwritten.stitchfix.com/apidocs/web/client-auth-api/index.html#:~:text=a%20new%20account-,Registration%20(V1)%20Web,-New%20client%20registration)
 * - [Implementation](https://github.com/stitchfix/client-auth-api/blob/main/app/controllers/api/v1/registrations_controller.rb)
 */
export const registerUser = (registrationRequestParameters: RegistrationRequestParameters | RegistrationRequestParametersOptionalLastName, isWafEnabled = false) => {
  const apiService = isWafEnabled ? wafClientAuthAxios : clientAuthAxios;
  const payload = registrationRequestParameters;
  const testAccountToken = cookies.get('test-account-token');
  const testAccountType = cookies.get('test-account-type');
  let config: AxiosRequestConfig = {};
  payload.options = {
    ...getDefaultOptions(),
    ...payload.options
  };
  if (testAccountToken && testAccountType) {
    config = {
      headers: {
        'X-SF-TEST-ACCOUNT-TOKEN': testAccountToken,
        'X-SF-TEST-ACCOUNT-TYPE': testAccountType
      }
    };
  }
  return apiService.post<RegistrationResponse>('registration', payload, config);
};

/**
 * A function that posts to the `/client-auth-api/api/linked_accounts/google/sign_up` endpoint.
 *
 * - [Documentation](https://unwritten.stitchfix.com/apidocs/web/client-auth-api/google_sign-up_(v2)/post_-_201_-_client_account_successfully_created.html)
 * - [Implementation](https://github.com/stitchfix/client-auth-api/blob/main/app/controllers/api/v2/linked_accounts/google_controller.rb)
 */
export const registerUserWithGoogle = (googleRegistrationRequestParameters: GoogleRegistrationRequestParameters, isWafEnabled = false) => {
  const apiService = isWafEnabled ? wafClientAuthV2Axios : clientAuthV2Axios;
  const payload = googleRegistrationRequestParameters;
  payload.options = {
    ...getDefaultOptions(),
    ...payload.options
  };
  return apiService.post<RegistrationResponse>('linked_accounts/google/sign_up', payload);
};